import React from "react";
import { useObjectStore } from "../zustand/objects";
import { IconPlayerPlay, IconPencil } from '@tabler/icons-react';
import StoryboardToolbarIcon from "./StoryboardToolbarIcon";
import EditorToolbarIcon from "./EditorToolbarIcon";
import { CHROME_TOOLBAR_ICON_GLYPH } from "../utils/editorChromeTheme";

const SwitchToPreviewButton = ({ mode, projectKey, iconColour, framed = false, inGroup = false }) => { 

  const {
    switchModes,
    currentObjectArtboard
  } = useObjectStore();

  const previewLabel = mode === "editor" ? "Preview in first person" : "Edit project";
  const href =
    mode === "editor"
      ? `/preview/${projectKey}?artboard=${currentObjectArtboard}`
      : `/editor/${projectKey}?artboard=${currentObjectArtboard}`;

  if (framed) {
    return (
      <StoryboardToolbarIcon
        label={previewLabel}
        component="a"
        href={href}
        target="_blank"
        rel="noreferrer"
        onClick={() => switchModes()}
      >
        {mode === "editor" ? (
          <IconPlayerPlay size={CHROME_TOOLBAR_ICON_GLYPH} />
        ) : (
          <IconPencil size={CHROME_TOOLBAR_ICON_GLYPH} />
        )}
      </StoryboardToolbarIcon>
    );
  }

  return (
    <EditorToolbarIcon
      label={previewLabel}
      onClick={() => switchModes()}
      component="a"
      href={href}
      target="_blank"
      rel="noreferrer"
      iconColour={iconColour}
      inGroup={inGroup}
      aria-label={previewLabel}
    >
      {mode === "editor" ? (
        <IconPlayerPlay size={CHROME_TOOLBAR_ICON_GLYPH} />
      ) : (
        <IconPencil size={CHROME_TOOLBAR_ICON_GLYPH} />
      )}
    </EditorToolbarIcon>
  );
};

export default SwitchToPreviewButton;
